import 'css-chunksrc/client/pages/projectPage/synthesisPage/submitReportButton/styles.scss';export default {
  "submitReportButton": "_submitReportButton_12kdq_1",
  "icon": "_icon_12kdq_22"
};